<script lang="ts">
import { defineComponent, h } from 'vue'

/**
 * Renders a string of trusted SVG markup as the sole child of a <g> wrapper.
 *
 * - Lucide-style icons (default): the wrapper applies the standard stroke
 *   attributes (fill="none", stroke="currentColor", stroke-width=2, etc).
 * - Brand icons (brand=true): the body is already self-contained (it carries
 *   its own fill colors), so the wrapper renders bare <g> with no inherited
 *   stroke. This prevents lucide's currentColor stroke from overriding brand
 *   fills.
 *
 * The HTML string is sourced exclusively from the static icon registry in
 * ./icons.ts, so it is safe.
 */
export default defineComponent({
  name: 'IconSvgBody',
  props: {
    html: { type: String, required: true },
    brand: { type: Boolean, default: false },
  },
  render() {
    if (this.brand) {
      return h('g', { innerHTML: this.html })
    }
    return h('g', {
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      innerHTML: this.html,
    })
  },
})
</script>
